import { render, staticRenderFns } from "./AppFooterMenu.vue?vue&type=template&id=702ef408&scoped=true"
import script from "./AppFooterMenu.vue?vue&type=script&lang=ts"
export * from "./AppFooterMenu.vue?vue&type=script&lang=ts"
import style0 from "./AppFooterMenu.vue?vue&type=style&index=0&id=702ef408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ef408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle,VSubheader})
